// extracted by mini-css-extract-plugin
module.exports = {"TermsDetails":"TermsAndConditions_TermsDetails__3_SYj","mainParagraph":"TermsAndConditions_mainParagraph__14-IZ"};